<template>
  <div class="fullscrean">
    <div>
      <img src="../assets/logo.png" style="width: 100px">
      <div class="mt-4" v-if="status">
        <h6 class="mb-1">Lamentamos o inconveniente!</h6>
        <p v-if="status === '0'">Não estamos mais disponíveis neste canal de vendas.</p>
        <p v-else>No momento este canal de vendas está indisponível.</p>
      </div>
      <div class="mt-4" v-else>
        <p>{{msg}}</p>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "StatusEmpresa",
      props: ['status'],
      data() {
        return {
          msg: ''
        }
      },

      created() {
        this.msg = process.env.VUE_APP_DESCRIPTION
      }
    }
</script>

<style scoped>
  .fullscrean {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 15px;
    text-align: center;
  }
</style>
